/**
 * @prettier
 * @flow
 */
import isString from 'lodash/isString';

export function upperCaseFirstLetter(value?: ?string): string {
    // TODO: Return maybe type
    if (value === undefined || value === null) {
        return (value: any);
    }
    if (!isString(value)) {
        return value;
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
}
